import {
  DocumentBlobKind,
  DocumentId,
  DocumentKind,
  SubdomainName,
} from "@bitory-gmbh/bsm";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { DocumentBlobUploadArea } from "@/services/backend/filestorage/components/document-blob-upload-area";
import { DocumentBlobTable } from "@/services/backend/filestorage/components/document-blob-table";
import { DocumentBlobKindSelect } from "@/services/backend/filestorage/components/document-blob-kind-select";
import { useState } from "react";

export function DocumentBlobCard({
  subdomain,
  documentKind,
  documentId,
  defaultKind = DocumentBlobKind.Attachment,
  accept,
  disabled = false,
}: {
  subdomain: SubdomainName;
  documentKind: DocumentKind;
  documentId: DocumentId;
  defaultKind?: DocumentBlobKind;
  accept?: string;
  disabled?: boolean;
}) {
  const [kind, setKind] = useState<DocumentBlobKind>(defaultKind);

  return (
    <Card className="relative">
      <CardHeader>
        <CardTitle>{t("Dateien")}</CardTitle>
      </CardHeader>
      <div className="absolute right-6">
        <DocumentBlobKindSelect
          value={kind}
          onValueChange={(k) => setKind(k as DocumentBlobKind)}
        />
      </div>
      <CardContent className="grid grid-cols-2 gap-4">
        <DocumentBlobUploadArea
          subdomain={subdomain}
          documentKind={documentKind}
          documentId={documentId}
          defaultKind={kind}
          accept={accept}
          disabled={disabled}
        />
        <DocumentBlobTable
          request={{ subdomain, documentKind, documentId, kind }}
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
}
